module.exports = __webpack_public_path__ + "images/22c99622815e17b61891f69007d0bc44-desk2.jpg";